import { __rest } from "tslib";
import * as React from "react";
import { forwardRef } from "react";
import clsx from 'clsx';
const _CaretLeftIcon = (_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return React.createElement("svg", Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", role: "presentation", width: 16, height: 16, className: clsx("cmp-icon", className), ref: ref }, props),
        React.createElement("path", { d: "M14.802 7.186A.662.662 0 0 0 14.333 7a.662.662 0 0 0-.469.186L9.198 11.56A.583.583 0 0 0 9 12c0 .17.066.316.198.44l4.666 4.374a.662.662 0 0 0 .47.186.66.66 0 0 0 .468-.186.582.582 0 0 0 .198-.44V7.626a.583.583 0 0 0-.198-.44Z" }));
};
const CaretLeftIcon = forwardRef(_CaretLeftIcon);
export default CaretLeftIcon;
//# sourceMappingURL=caret-left.js.map